var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMixsplit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4878 18.2797C16.6253 19.1422 15.6013 19.8264 14.4744 20.2932C13.3474 20.7599 12.1396 21.0002 10.9198 21.0002C9.70001 21.0002 8.49216 20.7599 7.36523 20.2932C6.23829 19.8264 5.21433 19.1422 4.35181 18.2797L10.9198 11.7117L17.4878 18.2797Z",
    fill: "#002D62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2929 18.4764L12.3484 13.6679L12.7116 13.5694L17.4571 18.3122L17.2929 18.4764Z",
    fill: "#012946"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4878 3.28598C16.6253 2.42346 15.6013 1.73927 14.4744 1.27247C13.3474 0.80568 12.1396 0.565426 10.9198 0.565426C9.70001 0.565426 8.49216 0.805681 7.36523 1.27247C6.23829 1.73927 5.21433 2.42346 4.35181 3.28598L10.9198 9.85397L17.4878 3.28598Z",
    fill: "#002D62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2929 3.08924L12.3484 7.8977L12.7116 7.99624L17.4571 3.25343L17.2929 3.08924Z",
    fill: "#012946"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2794 4.14881C20.1419 5.01133 20.8261 6.03529 21.2929 7.16223C21.7597 8.28917 22 9.49701 22 10.7168C22 11.9366 21.7597 13.1444 21.2929 14.2714C20.8261 15.3983 20.1419 16.4223 19.2794 17.2848L12.7114 10.7168L19.2794 4.14881Z",
    fill: "#002D62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4763 4.34374L14.6679 9.28825L14.5693 8.92508L19.3121 4.17956L19.4763 4.34374Z",
    fill: "#012946"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35706 4.14881C2.49454 5.01133 1.81035 6.03529 1.34356 7.16223C0.876763 8.28917 0.636508 9.49701 0.636508 10.7168C0.636508 11.9366 0.876764 13.1444 1.34356 14.2714C1.81035 15.3983 2.49454 16.4223 3.35706 17.2848L9.92505 10.7168L3.35706 4.14881Z",
    fill: "#002D62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16015 4.34374L7.96861 9.28825L8.06714 8.92508L3.32434 4.17956L3.16015 4.34374Z",
    fill: "#012946"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixsplit);
export default __webpack_public_path__ + "static/media/mixsplit.e48cfb1e3058813662885c8c9532d3e0.svg";
export { ForwardRef as ReactComponent };